import * as React from 'react';
import {
  Box,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableContainer,
} from '@mui/material';
import { MyClientsListProps } from './types';
import ClientTableHeader from './ClientTableHeader';
import ClientRow from './ClientRow';

const MyClientListDesktop = (props: MyClientsListProps) => {
  const users = props.query?.users || [];
  const loading = props.loading || false;
  const [sortProps, setSortProps] = React.useState<{
    by: string;
    order: 'asc' | 'desc';
  }>({ by: 'date', order: 'asc' });
  const handleRequestSort = React.useMemo(
    () => (property: string) => {
      const { by, order } = sortProps;
      const isCurrentlyAsc = by === property && order === 'asc';
      //const sprops = {
      //  by: property,
      //  order: isCurrentlyAsc ? 'desc' : 'asc',
      //};
      setSortProps({
        by: property,
        order: isCurrentlyAsc ? 'desc' : 'asc',
      });
    },
    [sortProps]
  );
  return (
    <Box sx={{ padding: 2 }}>
      <Paper sx={{ mt: 3, mb: 3 }}>
        {loading && <LinearProgress />}
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            size="small"
            aria-label="transactions"
            aria-labelledby="tableTitle"
          >
            <ClientTableHeader
              orderBy={sortProps.order}
              sortOrder={sortProps.order}
              onRequestSort={handleRequestSort}
              key="table-header"
            />
            <TableBody>
              {users.map((trx, index) => {
                if (trx === null) return null;
                return <ClientRow user={trx} key={index} />;
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default MyClientListDesktop;
